import { Form } from 'react-bootstrap';
import { useTranslation } from 'react-i18next';
import type { LeadType, ObjectType, TaskForType } from '@econtractor/types';
import useSettingsParams from 'hooks/useSettingsParams';
import { LeadSelected } from 'modules/lead';
import { ObjectSelected } from 'modules/objects';

export interface TaskForProps {
    taskFor: TaskForType;
    lead: LeadType | null;
    object: ObjectType | null;
    onTaskForChange: (taskFor: TaskForType) => void;
    onLeadChange: (lead: LeadType | null) => void;
    onObjectChange: (object: ObjectType | null) => void;
    disabled?: boolean;
    /** Заблокувати зміну типу (коли відкрито з заявки/об'єкта) */
    locked?: boolean;
}

const TaskFor = ({
    taskFor,
    lead,
    object,
    onTaskForChange,
    onLeadChange,
    onObjectChange,
    disabled = false,
    locked = false,
}: TaskForProps) => {
    const { t } = useTranslation(['Tasks']);
    const params = useSettingsParams();
    const allowLeads = params.tasksModule && params.tasksForLeads;
    const allowObjects = params.tasksModule && params.tasksForObjects;

    const handleTypeChange = (next: TaskForType) => {
        if (disabled || locked) return;
        if (next === 'lead' && !allowLeads) return;
        if (next === 'object' && !allowObjects) return;
        onTaskForChange(next);
        if (next === 'personal') {
            onLeadChange(null);
            onObjectChange(null);
        } else if (next === 'lead') {
            onObjectChange(null);
        } else {
            onLeadChange(null);
        }
    };

    return (
        <div className="task-for mb-3">
            {!locked && (
                <Form.Group className="mb-3">
                    <label className="form-label text-muted">{t('labelTaskFor')}</label>
                    <Form.Select
                        value={taskFor}
                        disabled={disabled}
                        onChange={(e) => handleTypeChange(e.target.value as TaskForType)}
                    >
                        <option value="personal">{t('taskFor.personal')}</option>
                        {allowLeads && <option value="lead">{t('taskFor.lead')}</option>}
                        {allowObjects && <option value="object">{t('taskFor.object')}</option>}
                    </Form.Select>
                </Form.Group>
            )}

            {taskFor === 'lead' && allowLeads && (
                <LeadSelected
                    value={lead}
                    onChange={onLeadChange}
                    disabled={disabled}
                    clearable={!locked}
                    maxHeight={200}
                />
            )}

            {taskFor === 'object' && allowObjects && (
                <ObjectSelected
                    value={object}
                    onChange={onObjectChange}
                    disabled={disabled}
                    clearable={!locked}
                    maxHeight={200}
                />
            )}
        </div>
    );
};

export default TaskFor;
